import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ArtCredit } from "@/components/ArtCredit";
import IMAGES from "@/data/treasuryImages.json";

export const SacredArtLightbox = ({ artwork, onClose }) => (
  <Dialog open={!!artwork} onOpenChange={(open) => { if (!open) onClose(); }}>
    {artwork && <DialogContent data-testid="art-lightbox" data-lenis-prevent className="z-[80] max-h-[90dvh] w-[calc(100%-2rem)] max-w-4xl overflow-y-auto rounded-lg bg-white p-5 pt-12" onCloseAutoFocus={(e) => { e.preventDefault(); document.querySelector(`[data-artwork="${artwork.id}"]`)?.focus(); }}>
      <img src={IMAGES[artwork.id]?.src} alt={artwork.title} data-testid="art-lightbox-image" className="mx-auto h-[48dvh] w-full object-contain" />
      <DialogTitle data-testid="art-lightbox-title" className="font-serif text-xl text-midnight">{artwork.title}</DialogTitle>
      <DialogDescription data-testid="art-lightbox-description" className="text-sm text-charcoal/90">{artwork.text}</DialogDescription>
      <ArtCredit imageId={artwork.id} prefix="art-lightbox" />
    </DialogContent>}
  </Dialog>
);